class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  startCountdownTimer() {
    const timerElement = document.getElementById("cart-countdown-timer");
    if (!timerElement) return;
    
    // Reset timer to 10 minutes
    let minutes = 10;
    let seconds = 0;
    
    // Clear any existing timer
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    
    // Update the timer display
    const updateTimer = () => {
      timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    
    // Initial display
    updateTimer();
    
    // Start the countdown
    this.countdownInterval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.countdownInterval);
          return;
        }
        minutes--;
        seconds = 59;
      } else {
        seconds--;
      }
      
      updateTimer();
    }, 1000);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");

    $(".gbfrequently-bought-with-main-whole-slider").slick({
      infinite: true,
      autoplaySpeed: 1000,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
    $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");
    
    // Start the countdown timer when drawer opens
    this.startCountdownTimer();
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    
    // Clear the countdown timer when drawer closes
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    $(".gbfrequently-bought-with-main-whole-slider").slick({
      infinite: true,
      autoplaySpeed: 1000,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
    $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    setTimeout(function () {
      var $slider = $(".gbfrequently-bought-with-main-whole-slider");
      if ($slider.length > 0 && !$slider.hasClass("slick-initialized")) {
        $slider.slick({
          infinite: true,
          autoplaySpeed: 1000,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          // adaptiveHeight: true
          //prevArrow: $('.our-customer-slider-prev'),
          //nextArrow: $('.our-customer-slider-next'),
        });
        $slider.css("opacity", "1");
      }
    }, 500);

    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  async updateQuantity(line, quantity, event, name, variantId) {
    if (this._hdChanging) return;
    this._hdChanging = true;
    const errorNode = document.getElementById('CartDrawer-CartErrors');
    try {
      const url = ((window.routes && window.routes.cart_change_url) || '/cart/change');
      const response = await fetch(url.endsWith('.js') ? url : url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({
          line: Number(line),
          quantity: Math.max(0, Number(quantity)),
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const cart = await response.json();
      if (!response.ok || cart.status >= 400) throw new Error(cart.description || cart.message || 'No pudimos actualizar tu carrito');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && cart.sections && cart.sections['cart-drawer']) {
        drawer.renderContents(cart);
      } else {
        // Safe fallback if Shopify's section renderer is unavailable.
        window.location.assign((window.routes && window.routes.cart_url) || '/cart');
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', {detail:{source:'hero-drop-drawer',cartData:cart}}));
      document.dispatchEvent(new CustomEvent('cart:update', {detail:{source:'hero-drop-drawer',cartData:cart}}));
    } catch (error) {
      if (errorNode) errorNode.textContent = error && error.message ? error.message : 'No pudimos actualizar tu carrito';
      else window.alert(error && error.message ? error.message : 'No pudimos actualizar tu carrito');
    } finally {
      this._hdChanging = false;
    }
  }

  getSectionsToRender() {
    setTimeout(function () {
      $(".gbfrequently-bought-with-main-whole-slider").slick({
        infinite: true,
        autoplaySpeed: 1000,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
      $(".gbfrequently-bought-with-main-whole-slider").css("opacity", "1");
    }, 500);

    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/* Hero Drop 29-10: el "Ahorra" de cada producto = precio tachado - precio que realmente paga (incluye 2º al 50 %, regalos y upsells) */
(function () {
  function hdNum(t) {
    var d = String(t || '').replace(/[^\d]/g, '');
    return d ? parseInt(d, 10) : NaN;
  }
  function hdFormat(n, sample) {
    var sep = /\d\.\d{3}/.test(sample) ? '.' : ',';
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function hdFixSavings() {
    document.querySelectorAll('.gb-price-drawer').forEach(function (box) {
      var oldEl = box.querySelector('s');
      var newEl = box.querySelector('strong');
      var badge = box.parentElement ? box.parentElement.querySelector('.gb-price-drawer-saving') : null;
      if (!oldEl || !newEl || !badge) return;
      var ref = hdNum(oldEl.textContent);
      var paid = hdNum(newEl.textContent);
      if (isNaN(ref) || isNaN(paid)) return;
      var saving = ref - paid;
      if (saving <= 0) {
        badge.style.display = 'none';
        return;
      }
      if (!badge.dataset.hdLabel) {
        badge.dataset.hdLabel = badge.textContent.replace(/[$\s\d.,]+$/, '').trim();
      }
      var sample = oldEl.textContent.trim();
      var money = sample.replace(/[\d][\d.,]*/, hdFormat(saving, sample));
      var text = badge.dataset.hdLabel + ' ' + money;
      if (badge.textContent.trim() !== text) badge.textContent = text;
      badge.style.display = '';
    });
  }

  /* Upsell de máscara (BOGOS) en el carrito: mostrar $19.990 tachado y $9.990, que es lo que realmente se cobra al agregarla con un lanzador.
     Si cambias el precio de la máscara o el descuento en BOGOS, actualiza estos dos valores. */
  var HD_UPSELL = { regular: 19990, offer: 9990, keyword: 'scara' };
  var HD_PRICE_RE = /^\s*\$?\s?(\d{1,3}(?:[.,]\d{3})+)(?:,00)?\s*(?:CLP)?\s*$/;
  function hdFixUpsell() {
    var root = document.querySelector('cart-drawer') || document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var hits = [];
    var node;
    while ((node = walker.nextNode())) {
      var m = HD_PRICE_RE.exec(node.nodeValue || '');
      if (!m || hdNum(m[1]) !== HD_UPSELL.regular) continue;
      var el = node.parentElement;
      if (!el || el.closest('[data-hd-upsell], tr.cart-item, s, del')) continue;
      var box = el, ok = false;
      for (var i = 0; i < 6 && box; i++, box = box.parentElement) {
        if ((box.textContent || '').indexOf(HD_UPSELL.keyword) !== -1) { ok = true; break; }
      }
      if (ok) hits.push(node);
    }
    hits.forEach(function (t) {
      var original = t.nodeValue.trim();
      var offer = original.replace(/\d{1,3}(?:[.,]\d{3})+/, hdFormat(HD_UPSELL.offer, original));
      var span = document.createElement('span');
      span.setAttribute('data-hd-upsell', '1');
      var s = document.createElement('s');
      s.textContent = original;
      s.style.opacity = '0.6';
      s.style.marginRight = '6px';
      var b = document.createElement('strong');
      b.textContent = offer;
      span.appendChild(s);
      span.appendChild(b);
      t.parentNode.replaceChild(span, t);
    });
  }
  var hdQueued = false;
  function hdSchedule() {
    if (hdQueued) return;
    hdQueued = true;
    requestAnimationFrame(function () {
      hdQueued = false;
      hdFixSavings();
      hdFixUpsell();
    });
  }
  function hdStart() {
    hdFixSavings();
    hdFixUpsell();
    new MutationObserver(hdSchedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hdStart);
  else hdStart();
})();
